<div class="success-icon-dialog is-closable">
    <kendo-dialog [title]="textOverride !== '' ? textOverride : 'Confirmation'" (close)="closeModal()">
        <div class="confirmation-content">
            <img 
                src="/assets/gifs/NowCheck.gif" 
                alt="Confirmation image" 
                width="200"
                height="200"
            />
        </div>
    </kendo-dialog>
</div>